<div class="trip-modal-container">
    <div class="">
        <div class="trip-modal-title">
            <p>Please wait! This will take few seconds</p>
            <p>While we search the best fares for you.</p>
        </div>
        <img src="assets/nosafer/images/l-logo.svg" alt="loader" />
        <div class="destination-section">
            <div class="dash-line"></div>
            <div class="dest-from">
                <p>Check In</p>
                <p>{{ hotelInfo.checkin | date }}</p>
            </div>
            <div class="dest-to">
                <p>Check Out</p>
                <p>{{ hotelInfo.checkout | date }}</p>
            </div>
        </div>
        <div class="dest-trip">
            <p>{{ hotelInfo.cityName }}</p>
        </div>
    </div>
</div>